<template>
  <custom-dialog
    :title="model.title"
    width="1550px"
    :visible="visible"
    :append-to-body="true"
    v-on="$listeners"
    class="accounts-confirm-dialog"
  >
    <div class="dialog-body">
      <div class="info-container">
        <div class="l">
          <bill-container :title="$t('fms_accounts_confirm_dialog.zhang_dan_lie_biao')">
            <accounts-registration-accounts-bill
              v-model="billList"
              :orderNum="getPaymentCode(registerMsg)"
              ref="payableBill"
              :tips="accountPayableTips"
              :auth="['copy']"
              :isLockBill="isLockBill"
              :paymentOrReceivable="paymentOrReceivable"
            ></accounts-registration-accounts-bill>
          </bill-container>
          <bill-container :title="$t('fms_accounts_confirm_dialog.zhi_fu_xin_xi')">
            <accounts-registration-msg-bill
              v-model="tradeList"
              :outerItem="firstOrderItem"
              ref="msgBill"
              :orderNum="getPaymentCode(registerMsg)"
              :payableTotal="payableTotal"
              :billInfo="registerMsg"
              tableCode="fms_confirm_msg_bill"
              :auth="['relativeFlow']"
              :paymentOrReceivable="paymentOrReceivable"
              :expandFlowMsg="true"
              @success="updateBankFlow"
            ></accounts-registration-msg-bill>
          </bill-container>
        </div>
        <div class="r">
          <div class="pay-info">
            <div class="title">{{ $t('fms_accounts_confirm_dialog.shou_kuan_xiang_qing') }}</div>
            <div class="order-code">
              <div class="label">{{ $t('fms_accounts_confirm_dialog.ding_dan_bian_hao') }}:</div>
              <div class="value">{{getPaymentCode(registerMsg)}}</div>
            </div>
            <!-- 收款时显示 -->
            <div class="order-code">
              <div class="label">{{ $t('fms_accounts_confirm_dialog.fu_kuan_fang') }}:</div>
              <div class="value">{{firstOrderItem.payableOrgName}}</div>
            </div>
            <div class="group-list">
              <div class="group">
                <div class="amount">
                  <div class="should-pay"><span class="bold">{{ $t('fms_accounts_confirm_dialog.shi_fu_he_ji') }}：</span>￥{{actualPayAmount}}</div>
                  <div class="details">
                    <div class="item">
                      <div class="key">{{ $t('fms_accounts_confirm_dialog.zu_lin_yu_e') }}</div>
                      <div class="val">￥{{expectUseRest}}</div>
                    </div>
                    <div class="item">
                      <div class="key">{{ $t('fms_accounts_confirm_dialog.dui_gong_zhuan_zhang') }}</div>
                      <div class="val">￥{{publicAmount}}</div>
                    </div>
                    <div class="item">
                      <div class="key">{{ $t('fms_accounts_confirm_dialog.xian_jin_zhi_fu') }}</div>
                      <div class="val">￥{{cashAmount}}</div>
                    </div>
                  </div>
                  <div class="should-pay expect-rest"><span class="bold">{{ $t('fms_accounts_confirm_dialog.ying_shou_he_ji') }}：</span>￥{{payableTotal}}</div>
                  <div
                    class="should-pay"
                    v-if="thisRest"
                  ><span class="bold">{{ $t('fms_accounts_confirm_dialog.ben_ci_jie_yu') }}：</span>￥{{thisRest}}</div>
                  <div class="amount">
                    <div class="should-pay paymentConfirmUser">{{ $t('fms_accounts_confirm_dialog.fu_kuan_cao_zuo_ren') }}：{{paymentConfirmUser || '-'}}</div>
                    <div class="should-pay">{{ $t('fms_accounts_confirm_dialog.fkczsj') }}：{{paymentConfirmTime || '-'}}</div>
                  </div>
                </div>
              </div>
              <div class="group">
                <div class="amount">
                  <div class="should-pay"><span class="bold">{{ $t('fms_accounts_confirm_dialog.yqrsk') }}：</span><span>￥{{total}}</span></div>
                  <div class="should-pay"><span class="bold">{{ $t('fms_accounts_confirm_dialog.yi_que_ren_shou_kuan') }}：</span><span :class="total !== confirmTotal ? 'red-font' : ''">￥{{confirmTotal}}</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button @click="onCancel">{{ $t('Common.com_close') }}</el-button>
      <el-button
        v-if="rejectCollection"
        @click="onReject"
      >{{ $t('fms_accounts_confirm_dialog.ju_jue_shou_kuan') }}</el-button>
      <el-button
        @click="onStore(true)"
        type="primary"
      >{{ $t('fms_accounts_confirm_dialog.zan_cun') }}</el-button>
      <el-button
        @click="onConfirm"
        type="primary"
      >{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
/** 确认收款 */

import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import commonDialogMixin from './dialogMixin';
import billContainer from './bill_container';
import accountsRegistrationAccountsBill from './accounts_registration_accounts_bill';
import accountsRegistrationMsgBill from './accounts_registration_msg_bill';
import mixins from './mixins';

export default {
  name: '',
  mixins: [dialogMixins, commonDialogMixin, mixins],
  components: {
    billContainer,
    accountsRegistrationAccountsBill,
    accountsRegistrationMsgBill,
  },
  props: {
    // model: {
    //   data: {
    //     // 选中的rows
    //     // billData: []
    //   }
    // }
    // false-收款  true-付款
    paymentOrReceivable: {
      type: Boolean,
      default: false
    },
    // 是否拒绝收款
    rejectCollection: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      name: 'accountsRegistrationDialog',
      isLockBill: false,
      registerMsg: {
        balance: '',
        deposit: '',
        billPaymentCode: '',
      },
      // 应付款账单信息
      billList: [],
      // 付款信息
      tradeList: [],
      userType: [],
      firstOrderItem: {},
      useRest: false,
      // 是否正在submiting
      submiting: false,
    };
  },
  computed: {
    // 本次结余 实付金额-应付金额，若本次结余为0时不显示此行）
    thisRest() {
      const actualPayAmount = this.actualPayAmount || 0;
      const payableTotal = this.payableTotal || 0;
      return Math.max(actualPayAmount - payableTotal, 0);
    },
    // 操作人: paymentConfirmUser
    paymentConfirmUser() {
      let billPayment = {};
      if (this.registerMsg && this.registerMsg.billPayment) {
        billPayment = this.registerMsg.billPayment;
      }
      return billPayment.paymentConfirmUser;
    },
    // 操作时间：paymentConfirmTime
    paymentConfirmTime() {
      let billPayment = {};
      if (this.registerMsg && this.registerMsg.billPayment) {
        billPayment = this.registerMsg.billPayment;
      }
      return this.$momentLocal(billPayment.paymentConfirmTime);
    },
    // 支付金额总和
    total() {
      const key = 'totalAmount';
      const list = this.tradeList;
      return list.reduce((total, item) => total + Number(item[key] || 0), 0);
    },
    // 已确认收款
    confirmTotal() {
      const key = 'totalAmount';
      const list = this.tradeList.filter(item => item.sellerTradeCode);
      return list.reduce((total, item) => total + Number(item[key] || 0), 0);
    },
    payableTotal() {
      return this.billList.reduce((total, item) => {
        const { paymentAmount = 0 } = item;
        const sum = paymentAmount;
        return sum + total;
      }, 0);
    },
    accountPayableAuth() {
      const ret = ['del', 'addPayableOrder', 'copy'];
      if (this.billList && this.billList.length) {
        const firstItem = this.billList[0];
        if (firstItem.isLockBill) {
          return ['copy'];
        }
      }
      return ret;
    },
    // 实付金额
    actualPayAmount() {
      const expectUseRest = this.expectUseRest || 0;
      const total = this.total || 0;
      return expectUseRest + total;
    },
    accountPayableTips() {
      const item = this.firstOrderItem;
      // 首期添加提示显示
      if (item && item.termNum === 1) {
        return this.$t('fms_accounts_confirm_dialog.sqxtszfhtddsbdsqkyyj');
      }
      return undefined;
    },
    balance() {
      return this.registerMsg.balance;
    },
    // 预计使用余额
    expectUseRest() {
      // // 是否使用余额
      // const useRest = this.useRest;
      // // 账单总额
      // const accountTotal = this.payableTotal || 0;
      // // 现有余额
      // const balance = this.useRest ? this.balance || 0 : 0;
      // if (!useRest) {
      //   return 0;
      // } else {
      //   if (balance >= accountTotal) {
      //     return accountTotal;
      //   } else {
      //     return balance;
      //   }
      // }
      const payableTotal = this.payableTotal || 0;
      const tradeTotal = this.total || 0;
      const balance = this.useRest ? this.balance || 0 : 0;
      const ret = payableTotal - tradeTotal >= balance ? balance : payableTotal - tradeTotal;
      return Math.max(ret, 0);
    },
    // 对公转账
    publicAmount() {
      const list = this.tradeList;
      if (this.dicMap.payment_class) {
        const ret = list.filter(item => `${item.tradeMethod}` === `${this.dicMap.payment_class.public_account}`);
        return ret.reduce((total, item) => {
          const { totalAmount = 0 } = item;
          return total + Number(totalAmount);
        }, 0);
      }
      return 0;
    },
    // 现金支付
    cashAmount() {
      const list = this.tradeList;
      if (this.dicMap.payment_class) {
        const ret = list.filter(item => `${item.tradeMethod}` === `${this.dicMap.payment_class.cash}`);
        return ret.reduce((total, item) => {
          const { totalAmount = 0 } = item;
          return total + Number(totalAmount);
        }, 0);
      }
      return 0;
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    // 更新银行流水
    updateBankFlow() {
      const billPaymentCode = this.getPaymentCode(this.registerMsg);
      this.$getJSON(`${apis.paymentBankFlowList}/${billPaymentCode}`).then((res) => {
        this.tradeSellerBos = res.data;
      });
    },
    getReqData() {
      return {
        billPaymentCode: this.getPaymentCode(this.registerMsg),
        paymentCode: this.getPaymentCode(this.registerMsg),
        billIdList: this.billList.map(item => item.billId),
        tradeList: this.tradeList,
        useBalance: this.useRest,
        payableOrgName: this.firstOrderItem.payableOrgName,
        payableOrgId: this.firstOrderItem.payableOrgId,
      };
    },

    // 拒绝
    onReject() {
      if (this.submiting || !this.visible) {
        return;
      } else {
        this.submiting = true;
      }
      this.$showConfirm(this.$t('fms_accounts_confirm_dialog.nqdyjcddzhfkfzcxfkm')).then(() => {
        const billPaymentCode = this.getPaymentCode(this.registerMsg);
        this.$postJSON(`${apis.paymentRevoke}/${billPaymentCode}`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
          this.$emit('success');
          this.closeDialog();
        }).finally(() => {
          this.submiting = false;
        });
      }).catch(() => {
        this.submiting = false;
      });

    },

    closeDialog() {
      this.visible = false;
    },
    onCancel() {
      this.closeDialog();
    },
    // 暂存
    onStore() {
      // 确认收款，点击暂存直接退出弹窗
      this.$message({
        type: 'success',
        message: this.$t('fms_accounts_confirm_dialog.zan_cun_cheng_gong'),
      });
      this.closeDialog();
    },
    // 保存
    onConfirm() {
      if (this.submiting || !this.visible) {
        return;
      } else {
        this.submiting = true;
      }
      if (this.payableTotal < 0) {
        this.$message.error(this.$t('fms_accounts_confirm_dialog.yfjehjbnxy0'));
        this.submiting = false;
        return;
      }
      if (this.billList.length === 0) {
        this.$message.error(this.$t('fms_accounts_confirm_dialog.qxzyfkxx'));
        this.submiting = false;
        return;
      }
      const useRest = this.useRest;
      if (this.tradeList.length === 0) {
        if (useRest) {
          if (this.registerMsg.balance < this.payableTotal) {
            this.$message.error(this.$t('fms_accounts_confirm_dialog.qxzfkxx'));
            this.submiting = false;
            return;
          }
        } else {
          this.$message.error(this.$t('fms_accounts_confirm_dialog.qxzfkxx'));
          this.submiting = false;
          return;
        }
      } else {
        // 公账列表
        const accountList = this.tradeList.filter(item => `${item.tradeMethod}` === `${this.dicMap.payment_class.public_account}`);
        // 公账需要绑定流水
        if (accountList.length) {
          const noBindFlow = accountList.some(item => !item.sellerTradeCode);
          if (noBindFlow) {
            this.$message.error(this.$t('fms_accounts_confirm_dialog.qglls'));
            this.submiting = false;
            return;
          }
        }

      }


      this.$showConfirm(this.$t('fms_accounts_confirm_dialog.nqdyjsdlfkfqbkxm')).then(() => {
        const billPaymentCode = this.getPaymentCode(this.registerMsg);

        const reqData = this.getReqData();
        this.$postJSON(`${apis.paymentConfirmPayment}/${billPaymentCode}`, reqData, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_edit_success'),
          });
          this.$emit('success');
          this.closeDialog();
        }).finally(() => {
          this.submiting = false;
        });
      }).catch(() => {
        this.submiting = false;
      });

    },
    // 去除传入的billData中的押金字段
    initBillList(list) {
      const ret = list.map((item) => {
        const obj = {
          ...item
        };
        obj.depositFee = 0;
        return obj;
      });
      return ret;
    },
    getPageInfo() {
      const firstItem = this.billList[0];
      const url = this.getPaymentInfoReqUrl(firstItem);
      return this.$getJSON(url).then((res) => {
        const data = res.data;
        if (data && data.billPayment) {
          this.isLockBill = data.billPayment.isLockBill;
        }
        this.registerMsg = data;
        this.registerMsg.balance = this.getBalance(data, 'payment-register');
        this.registerMsg.deposit = this.registerMsg.deposit || 0;
        if (data.orderViewList && data.orderViewList.length) {
          this.billList = this.formatRefundBill(data.orderViewList);
        }
        if (data.tradeBoList && data.tradeBoList.length) {
          this.tradeList = [...data.tradeBoList];
          data.tradeBoList.forEach((item, index) => {
            this.$getJSON(`${apis.OssAttach}/${item.tradeId}/fms.trade.certificate`).then((imgRes) => {
              this.$set(data.tradeBoList[index], 'attachs', this.formatAttachs(imgRes.data));
            });
          });
        }
        if (data.billPayment && data.billPayment.isUseBalance) {
          this.useRest = true;
        }
      });
    },
  },
  created() { },
  mounted() {
    this.getDicMap('payment_class');
    this.billList = this.formatRefundBill(this.initBillList(this.model.data.billData));
    this.firstOrderItem = this.billList[0];
    this.getPageInfo();
  },
};
</script>

<style lang="scss">
.accounts-confirm-dialog {
  .paymentConfirmUser {
    margin-top: 15px;
  }
  .bold {
    font-weight: bold;
  }
  .red-font {
    color: #ff5c5b;
  }
  .expect-rest {
    margin-top: 24px;
  }
  .info-container {
    display: flex;
    .l {
      flex: 1;
      padding-right: 20px;
    }

    .r {
      width: 350px;

      .pay-info {
        .item {
          overflow: hidden;
          &:nth-child(n + 2) {
            margin-top: 4px;
          }
          .key {
            float: left;
            font-size: 12px;
            color: #4d4d4d;
            line-height: 18px;
          }
          .val {
            overflow: hidden;
            font-size: 12px;
            color: #1a1a1a;
            line-height: 18px;
            padding-left: 16px;
            white-space: normal;
          }
        }
      }

      .pay-info {
        background: #fff;
        padding: 10px;
        border: 1px solid whitesmoke;
        border-radius: 4px;
        overflow: hidden;
        border-top: 4px solid #00a0d9;

        > .title {
          line-height: 30px;
          font-weight: bold;
          font-size: 14px;
          margin-bottom: 10px;
        }

        .order-code {
          color: #4d4d4d;
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 10px;
          overflow: hidden;

          .label {
            float: left;
          }
          .value {
            overflow: hidden;
            padding-left: 16px;
          }
        }

        .group {
          padding: 24px 0;
          border-top: 1px solid rgba(245, 245, 245, 1);

          // &:last-child {
          //   border-bottom: 1px solid rgba(245, 245, 245, 1);
          // }
        }

        .rest {
          overflow: hidden;
          line-height: 20px;
          .label {
            font-size: 14px;
            float: left;
            color: #4d4d4d;
          }
          .value {
            float: left;
            font-size: 14px;
            color: #1a1a1a;
            padding-left: 16px;
          }
          .use-rest {
            float: right;
            .use-label {
              float: left;
              color: #4d4d4d;
            }
            .use-cb {
              float: left;
              margin-left: 10px;
            }
          }
        }

        .amount {
          .should-pay {
            line-height: 24px;
            color: #4d4d4d;
            font-size: 14px;
          }

          .details {
            background: rgba(248, 249, 250, 1);
            padding: 16px;
            margin-top: 16px;
            .item {
              line-height: 20px;
              font-size: 14px;
              overflow: hidden;
              &:nth-child(n + 2) {
                margin-top: 12px;
              }
              .key {
                color: #4d4d4d;
                float: left;
              }
              .val {
                color: #1a1a1a;
                float: right;
              }
            }
          }

          .actual-pay {
            overflow: hidden;
            line-height: 24px;
            font-size: 14px;
            font-weight: bold;
            margin-top: 20px;
            .key {
              float: left;
              color: #1a1a1a;
            }
            .val {
              float: left;
              color: #00a0d9;
            }
          }
        }

        .btn-content {
          padding-top: 24px;
          padding-bottom: 10px;

          .btn {
            display: block;
            width: 100%;
            margin-left: 0 !important;
            &:nth-child(n + 2) {
              margin-top: 24px;
            }
          }
        }
      }
    }
  }
}
</style>
